import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { getTeachers } from "../../redux/actions/teacherActions";
import AppSelectFilter from "./AppSelectFilter";

interface Props {
  value: string;
  onChange: (teacherId: string) => void;
  branchId?: string;
  label?: string;
  allLabel?: string;
  minWidth?: number | string;
}

export const TeacherSelectFilter: React.FC<Props> = ({
  value,
  onChange,
  branchId,
  label = "Teacher",
  allLabel = "All Teachers",
  minWidth = 150,
}) => {
  const dispatch = useAppDispatch();
  const {
    items: teachers,
    loadingFetchAll: loading,
    errorFetchAll: error,
  } = useAppSelector((state) => state.teacher);
  const attempted = useRef(false);

  useEffect(() => {
    if (!teachers.length && !loading && !error && !attempted.current) {
      attempted.current = true;
      dispatch(getTeachers(branchId ? { branchId } : undefined));
    }
  }, [dispatch, teachers.length, loading, error, branchId]);

  return (
    <AppSelectFilter
      label={label}
      value={value}
      onChange={onChange}
      options={teachers.map((t) => ({
        value: t.id,
        label: t.name ?? "Unnamed Teacher",
      }))}
      allLabel={allLabel}
      minWidth={minWidth}
    />
  );
};

export default TeacherSelectFilter;
